"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.LogicalSelect = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _isEqual2 = _interopRequireDefault(require("lodash/isEqual"));

var _uniq2 = _interopRequireDefault(require("lodash/uniq"));

var _invariant = _interopRequireDefault(require("invariant"));

var _SelectField = require("../SelectField");

var _Field = require("../Field");

/**
 * This class wraps Select to create a "Logical" select, where values can be any type and onChange
 * returns the new value directly.
 */
var LogicalSelect =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2["default"])(LogicalSelect, _React$Component);

  function LogicalSelect() {
    (0, _classCallCheck2["default"])(this, LogicalSelect);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(LogicalSelect).apply(this, arguments));
  }

  (0, _createClass2["default"])(LogicalSelect, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      // Cannot use PureRenderMixin because we need deep comparison for props.options
      return !(0, _isEqual2["default"])(nextProps, this.props);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          options = _this$props.options,
          optionFormatter = _this$props.optionFormatter,
          otherProps = (0, _objectWithoutProperties2["default"])(_this$props, ["options", "optionFormatter"]);
      /**
       * When options is an Array, construct an object by applying the optionFormatter function
       * to each value.
       */

      if (Array.isArray(options)) {
        var mappedOptions = {};
        options.forEach(function (val) {
          var formatted = optionFormatter(val);
          (0, _invariant["default"])(typeof formatted === 'string' || typeof formatted === 'number', 'When passing an array of options to LogicalSelect, "optionFormatter" must ' + 'return a string or number.');
          mappedOptions[formatted] = val;
        });
        var keys = Object.keys(mappedOptions);
        var uniqueOptions = (0, _uniq2["default"])(keys);
        (0, _invariant["default"])(uniqueOptions.length === keys.length, 'All options in a LogicalSelect must have a unique key.');
        options = mappedOptions;
      }
      /**
       * Create an object to pass to Select by mirroring keys into values
       */


      var keyedOptions;

      if (options) {
        keyedOptions = {};
        Object.keys(options).forEach(function (key) {
          keyedOptions[key] = key;
        });
      }
      /**
       * Set the value of the inner Select to the respective key
       */


      Object.keys(options).forEach(function (key) {
        if ((0, _isEqual2["default"])(otherProps.value, options[key])) {
          otherProps.value = key;
        }
      });
      /**
       * Extract the real value to pass through to higher onChange listeners
       */

      var prevOnChange = otherProps.onChange;

      otherProps.onChange = function (e) {
        return prevOnChange(options[e.target.value]);
      };

      return _react["default"].createElement(_SelectField.Select, (0, _extends2["default"])({}, otherProps, {
        options: keyedOptions
      }));
    }
  }]);
  return LogicalSelect;
}(_react["default"].Component);

exports.LogicalSelect = LogicalSelect;
LogicalSelect.defaultProps = {
  optionFormatter: function optionFormatter(x) {
    return x;
  }
};
LogicalSelect.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Return the new logical value when the input changes
   */
  onChange: _propTypes["default"].func,

  /**
   * Object with entries like { 'display name' : value } or an array of values.
   */
  options: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].array]).isRequired,

  /**
   * When the options prop is an array, format the keys with this function. values remain in original form
   */
  optionFormatter: _propTypes["default"].func,

  /**
   * The logical value to be selected
   */
  value: _propTypes["default"].any
} : {};
LogicalSelect.displayName = 'LogicalSelectField';
var LogicalSelectField = (0, _Field.wrap)(LogicalSelect);
var _default = LogicalSelectField;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@zillow/react-zsg/LogicalSelectField/index.js
// module id = 402
// module chunks = 0